import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { toast } from 'react-toastify';
import Logo from '../components/Logo';

export default function ForgotPasswordPage() {
  const [email, setEmail]   = useState('');
  const [sent, setSent]     = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      toast.error('Request failed — please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-tea-50 flex items-center justify-center px-4">
      <div className="card max-w-md w-full">
        <Link to="/" aria-label="Aloha Amino home" className="flex items-center justify-center gap-2 font-bold text-tea-700 text-2xl mb-6">
          <Logo className="h-7 w-7" />
          Aloha Amino
        </Link>
        <h1 className="text-2xl font-bold text-center mb-2">Reset Password</h1>
        <p className="text-gray-500 text-sm text-center mb-6">
          Enter your email and we'll send you a reset link.
        </p>

        {sent ? (
          <div className="text-center mt-4">
            <p className="text-tea-700 font-medium">Check your email for the reset link.</p>
            <Link to="/login" className="btn-primary mt-6 inline-block">Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="input-field"
              placeholder="your@email.com"
            />
            <button type="submit" disabled={loading} className="btn-primary w-full py-3">
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <p className="text-center mt-6 text-gray-500 text-sm">
          <Link to="/login" className="text-tea-600 hover:underline">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
